import {MathJax} from "better-react-mathjax";
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import { useState } from 'react';
import Tooltip from '@mui/joy/Tooltip';

export default function SpinSelector(props) {
    const { value, onChange, locked, toolTip } = props;
    const [toolTipSpin, setToolTipSpin] = useState(true);

    const spinFrac = {
        0: "0",
        1: "\\frac{1}{2}",
        2: "1",
        3: "\\frac{3}{2}",
        4: "2",
        5: "\\frac{5}{2}",
        6: "3",
        7: "\\frac{7}{2}",
        8: "4",
        9: "\\frac{9}{2}",
        10: "5",
        11: "\\frac{11}{2}",
        12: "6"
    }
    return (
    <Tooltip title={toolTipSpin ? toolTip: null}>
        <Select onChange={onChange} value={value} disabled={locked} placeholder="Spin" onListboxOpenChange={() => setToolTipSpin(!toolTipSpin)} >
        {/* <Option value={0}>0</Option>
        <Option value={1}>  <MathJax>{"`" + spinFrac[1] + "`"}</MathJax>   </Option>  
        <Option value={2}>1</Option>
        <Option value={3}>  <MathJax>{"`" + spinFrac[3] + "`"}</MathJax>   </Option>
        <Option value={4}>2</Option>
        <Option value={5}>  <MathJax>{"`" + spinFrac[5] + "`"}</MathJax>   </Option>
        <Option value={6}>3</Option>
        <Option value={7}>  <MathJax>{"`" + spinFrac[7] + "`"}</MathJax>   </Option>
        <Option value={8}>4</Option>
        <Option value={9}>  <MathJax>{"`" + spinFrac[9] + "`"}</MathJax>   </Option> */}
        <Option value={0}>0</Option>
        <Option value={1}>1/2</Option>
        <Option value={2}>1</Option>
        <Option value={3}>3/2</Option>
        <Option value={4}>2</Option>
        <Option value={5}>5/2</Option>
        <Option value={6}>3</Option>
        <Option value={7}>7/2</Option>
        <Option value={8}>4</Option>
        <Option value={9}>9/2</Option>
        <Option value={10}>5</Option>
        <Option value={11}>11/2</Option>
        </Select>
    </Tooltip>
    );
}